export enum ModuleType {
  Plan = '1',
  Amendment = '2',
  Proposal = '3'
}
